import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import toast from "react-hot-toast";
import UserPicker from "./UserPicker";
import { useModalDismiss } from "./useModalDismiss";

interface Props {
    pageId: string;
    currentOwnerId: string | null;
    onSave: (ownerId: string | null) => void;
    onCancel: () => void;
}

export default function OwnerForm({ pageId, currentOwnerId, onSave, onCancel }: Props) {
    const [ownerId, setOwnerId] = useState<string | null>(currentOwnerId);
    const [saving, setSaving] = useState(false);
    const { show, dismiss, onExited } = useModalDismiss(onCancel, () => onSave(ownerId));

    const value = ownerId ? [ownerId] : [];
    const onChange = (ids: string[]) => {
        setOwnerId(ids.length > 0 ? ids[ids.length - 1] : null);
    };

    function handleSave() {
        setSaving(true);
        axios.patch(`/api/manuals/pages/${pageId}/owner`, { ownerId })
            .then(res => {
                if (res.data.success) {
                    toast.success(ownerId ? "Owner updated" : "Owner cleared");
                    dismiss("save");
                } else {
                    toast.error(res.data.message || "Failed to save");
                    setSaving(false);
                }
            })
            .catch(err => {
                toast.error(err.response?.data?.message || "Failed to save");
                setSaving(false);
            });
    }

    return (
        <Modal show={show} onHide={() => dismiss("cancel")} onExited={onExited} centered backdropClassName="m-modal-backdrop">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 17, fontWeight: 600 }}>Change page owner</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ color: "#64748b", fontSize: 13, marginTop: -4, marginBottom: 12 }}>
                    The owner is responsible for keeping this page up to date.
                </p>
                <label className="m-label">Owner</label>
                <UserPicker value={value} onChange={onChange} placeholder="Type to assign..." excludeReadonly />
                {ownerId && (
                    <button
                        type="button"
                        className="m-btn m-btn-ghost m-btn-sm"
                        style={{ marginTop: 10 }}
                        onClick={() => setOwnerId(null)}
                    >
                        Clear owner
                    </button>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="m-btn m-btn-ghost" onClick={() => dismiss("cancel")}>Cancel</button>
                <button type="button" className="m-btn m-btn-primary" onClick={handleSave} disabled={saving}>
                    {saving ? "Saving…" : "Save"}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
